// extracted by mini-css-extract-plugin
export var askAiIcon = "_q1-9";
export var container = "_q1-0";
export var groupSeparator = "_q1-a";
export var highlight = "_q1-4";
export var resultIcon = "_q1-5";
export var resultItem = "_q1-7";
export var resultSubtitle = "_q1-3";
export var resultTitle = "_q1-2";
export var resultsList = "_q1-1";
export var searchGroup = "_q1-6";
export var selected = "_q1-8";